import type { ReactNode } from "react";
import { Fragment, useId } from "react";
import { Icon } from "~/components/base/Icon";
import { useT } from "~/hooks/useT";

interface AppTopbarProps {
  crumbs?: string[];
  actions?: ReactNode;
  onSearch?: (q: string) => void;
}

export function AppTopbar({ crumbs = [], actions, onSearch }: AppTopbarProps) {
  const { t } = useT();
  const searchId = useId();
  return (
    <div className="topbar">
      <div className="topbar__crumbs">
        {crumbs.map((c, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <Fragment key={`${c}-${String(i)}`}>
              {i > 0 ? <span className="sep">/</span> : null}
              <span
                style={{
                  color: isLast ? "var(--ink)" : "var(--ink-3)",
                  fontWeight: isLast ? 500 : 400,
                }}
              >
                {c}
              </span>
            </Fragment>
          );
        })}
      </div>

      <div className="topbar__actions">
        {onSearch ? (
          <div style={{ position: "relative", width: 260 }}>
            <label htmlFor={searchId} className="sr-only" style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0,0,0,0)" }}>
              {t("search")}
            </label>
            <span
              style={{
                position: "absolute",
                left: 10,
                top: 10,
                color: "var(--ink-4)",
              }}
            >
              <Icon name="search" size={14} />
            </span>
            <input
              id={searchId}
              className="input"
              style={{ paddingLeft: 30, height: 32 }}
              placeholder={t("search_placeholder")}
              onChange={(e) => onSearch(e.target.value)}
            />
          </div>
        ) : null}
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          title={t("notifications")}
          aria-label={t("notifications")}
        >
          <Icon name="bell" size={15} />
        </button>
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          title={t("help")}
          aria-label={t("help")}
        >
          <Icon name="help" size={15} />
        </button>
        {actions}
      </div>
    </div>
  );
}
